import { Clock, Loader2 } from "lucide-react";
import { FormattedMessage } from "react-intl";
import { TemplateListItem } from "~/api/model/templateListItem";
import { Button } from "~/components/ui/button";
import { trackEvent } from "~/utils/analytics";

export const GenerateReportView = ({
  template,
  onGenerate,
  isGenerating,
  isPending,
}: {
  template: TemplateListItem;
  onGenerate: (id: string) => void;
  isGenerating: boolean;
  isPending: boolean;
}) => (
  <div className="py-8">
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1">
        <div className="text-xs text-muted-foreground">
          <FormattedMessage
            id="reportArea.generate.title"
            defaultMessage="Generate Report"
          />
        </div>
        <h2 className="text-lg font-semibold normal-case">{template.name}</h2>
        <p className="text-sm text-muted-foreground">{template.definition}</p>
      </div>
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-3">
          {isGenerating ? (
            <>
              <Button disabled>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                <FormattedMessage
                  id="reportArea.generating"
                  defaultMessage="Generating..."
                />
              </Button>
            </>
          ) : (
            <>
              <Button
                onClick={() => {
                  trackEvent({
                    eventName: "app/report/generate.button/click",
                    properties: {
                      templateId: template.id,
                      templateName: template.name,
                    },
                  });
                  onGenerate(template.id);
                }}
                disabled={isPending}
              >
                <FormattedMessage
                  id="reportArea.generate"
                  defaultMessage="Generate"
                />
              </Button>
              <div className="flex items-center gap-1">
                <Clock className="h-3 w-3 text-muted-foreground" />
                <span className="text-xs text-muted-foreground">
                  <FormattedMessage
                    id="reportArea.approxMinutes"
                    defaultMessage="~{minutes} min"
                    values={{ minutes: 1 }}
                  />
                </span>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  </div>
);
